import { render, staticRenderFns } from "./ReceiveScanner.vue?vue&type=template&id=16b6a3fe"
import script from "./ReceiveScanner.vue?vue&type=script&lang=js"
export * from "./ReceiveScanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports